export default __webpack_public_path__ + "static/media/640_VH_Alte_Bleiche_StreamDiver.d2ad3184.jpg";